import styled from 'styled-components'
import {ButtonView} from './styled'

const ButtonIcon = styled.div`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${process.env.REACT_APP_PUBLIC_URL}/assets/${props => props.icon});
  background-color: ${props => props.background};
  border: ${props => props.border};
  height: ${props => props.theme.social?.height || '44px'};
  width: ${props => props.theme.social?.width || '44px'};
  border-radius: ${props => props.theme.social?.borderRadius || '50%'};
  transition: transform 0.15s ease-out;

  ${ButtonView}:hover && {
    background-image: url(${process.env.REACT_APP_PUBLIC_URL}/assets/${props => props.hoverIcon || props.icon});
    background-color: ${props => props.hoverBackground};
    border: ${props => props.hoverBorder};
    transform: scale(1.1);
  }

  ${ButtonView}:active && {
    background-image: url(${process.env.REACT_APP_PUBLIC_URL}/assets/${props => props.activeIcon || props.icon});
  }
`

export default ButtonIcon
